var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.firms, function (firm) {
      return _c(
        "div",
        { key: firm.id },
        [
          _c("sui-list", { staticClass: "client-list" }, [
            _c("div", { staticClass: "client-list-item" }, [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.getFirmData(firm.id)
                    },
                  },
                },
                [
                  _c("sui-list-icon", { attrs: { name: "building" } }),
                  _c("label", [_vm._v(_vm._s(firm.name))]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }